import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Filter icon button with a badge showing how many filters are active.
 */
@customElement('sdb-filter-button')
class SdbFilterButton extends LitElement {

    @property({ type: Number })
    accessor count = 0;

    @property({ type: String })
    accessor label = '';

    static styles = css`
        :host {
            position: relative;
            display: inline-flex;
        }

        .badge {
            position: absolute;
            top: -4px;
            right: -6px;
            min-width: 16px;
            height: 16px;
            padding: 0 4px;
            box-sizing: border-box;
            border-radius: 8px;
            background: var(--btn-primary, #1e9b8f);
            color: #fff;
            font-size: 11px;
            line-height: 16px;
            text-align: center;
            pointer-events: none;
        }

        .badge[hidden] {
            display: none;
        }
    `;

    render() {
        return html`
            <sdb-content-iconbutton
                icon="fal fa-filter"
                title=${this.label}
                aria-label=${this.label}>
            </sdb-content-iconbutton>
            <span class="badge" ?hidden=${!this.count}>${this.count}</span>
        `;
    }
}
